import { render, staticRenderFns } from "./ChatSearchFilter.vue?vue&type=template&id=4c79af58&"
import script from "./ChatSearchFilter.vue?vue&type=script&lang=js&"
export * from "./ChatSearchFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports